import React from "react";
import theme from "app/Theme/Theme";
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const WenIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <G clipPath="url(#a)">
      <Path
        d="M21.61 19.39 18.21 16a7.92 7.92 0 0 0 1.69-4.9 8 8 0 1 0-8 8 7.92 7.92 0 0 0 4.9-1.69l3.39 3.4a1.002 1.002 0 0 0 1.639-.325 1 1 0 0 0-.219-1.095ZM5.9 11.1a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path
          fill="transparent"
          transform="translate(.9 .1)"
          d="M0 0h24v24H0z"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default WenIcon;
